import type { Route } from '../adapter';
import { assistantRoutes } from './assistants';
import { catalogRoutes } from './catalog';
import { charityRoutes } from './charities';
import { curationRoutes } from './curation';
import { devTrackerRoutes } from './dev-tracker';
import { eventRoutes } from './events';
import { materialRoutes } from './materials';
import { messageRoutes } from './messages';
import { noteRoutes } from './notes';
import { organizationRoutes } from './organizations';
import { resourceRoutes } from './resources';
import { shipmentRoutes } from './shipments';
import { templateRoutes } from './templates';

/** Every route the sandbox answers, first match wins. */
export const sandboxRoutes: readonly Route[] = [
  ...eventRoutes,
  ...materialRoutes,
  ...shipmentRoutes,
  ...assistantRoutes,
  ...charityRoutes,
  ...noteRoutes,
  ...templateRoutes,
  ...messageRoutes,
  ...catalogRoutes,
  ...curationRoutes,
  ...organizationRoutes,
  ...resourceRoutes,
  ...devTrackerRoutes,
];
